import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import ReducerEntityPrefixTypes from "../../../../../enums/reducer/reducerEntityPrefixTypes";
import ReducerNamespaceTypes from "../../../../../enums/reducer/reducerNamespaceTypes";
import { type BaseIntegrationConfigs } from "../../types";

export type IntegrationDetailsState<T extends BaseIntegrationConfigs = BaseIntegrationConfigs> = {
  data: T;
  isLoading: boolean;
  error?: Error;
};

const initialState: IntegrationDetailsState = {
  data: {} as BaseIntegrationConfigs,
  isLoading: true,
  error: undefined,
};

const integrationDetailsSlice = createSlice({
  name: `${ReducerNamespaceTypes.Accounts}/${ReducerEntityPrefixTypes.Integrations}/details`,
  initialState,
  reducers: {
    fetchBegin(state) {
      state.isLoading = true;
    },
    fetchSuccess(state: IntegrationDetailsState, action: PayloadAction<BaseIntegrationConfigs>) {
      state.data = action.payload;
      state.isLoading = false;
    },
    fetchFailure(state: IntegrationDetailsState, action: PayloadAction<Error>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    triggerSync(state: IntegrationDetailsState) {
      state.data.isSyncRunning = true;
    },
    reset() {
      return { ...initialState };
    },
  },
});

export const { fetchBegin, fetchSuccess, fetchFailure, triggerSync, reset } = integrationDetailsSlice.actions;

export default integrationDetailsSlice.reducer;
